import useSplitedTableByColumn from '../../../hooks/useSplitedTableByColumn';
import { Table } from '../../Table';
import { StyledTables } from '../style';
import { TableComponentProps } from '../types';

const _tables = [
  {
    name: "As at the reporting date, what percentage of the AIF's NAV is subject to the following arrangements?",
    order: 213,
    columnLables: {
      side_pocket_rate: {
        name: 'Side pockets (in %)',
        letter: 'A'
      },
      gates_rate: {
        name: 'Gates (in %)',
        letter: 'B'
      },
      dealing_suspension_rate: {
        name: 'Suspension of dealing (in %)',
        letter: 'C'
      },
      other_arrangement_rate: {
        name: 'Other arrangements (in %)',
        letter: 'D'
      },
      other_arrangement_type: {
        name: 'There are any other arrangements (210D), please provide a description of the arrangement(s)',
        letter: 'E'
      }
    }
  }
];

export function Arragements({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    tables,
    columns: columns,
    onChange: onChange
  } = useSplitedTableByColumn({
    data: funds[currentDataKey]?.fund_data?.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT,
    onChangeFund,
    schema: schema.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.INVESTOR_ILLIQUID_ASSET_ARRANGEMENT?.field_names ||
      [],
    tableName: 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT',
    tables: _tables,
    isMultiFunds,
    isSingleData: true,
    funds
  });

  return (
    <StyledTables id="fca-reporttables-arrangements-group">
      {tables.map((rows, index) => (
        <Table
          id={`fca-reporttables-arrangements-table-${index + 1}`}
          key={index + 'INVESTOR_ILLIQUID_ASSET_ARRANGEMENT-2'}
          handleChanges={onChange}
          columns={columns}
          rows={rows}
          stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
        />
      ))}
    </StyledTables>
  );
}
